var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatalogMenu5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 16,
    viewBox: "0 0 27 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6491 0.542526L13.6128 14.7561C13.7286 15.032 13.7005 15.3487 13.538 15.599C13.3754 15.8494 13.1003 16 12.8054 16H8.82247L6.84169 5.54522L4.86092 16H0.878003C0.583064 16 0.307848 15.8494 0.145375 15.599C-0.0172021 15.3487 -0.0452564 15.032 0.0704938 14.7561L6.03429 0.542526C6.1723 0.21348 6.49007 0 6.84169 0C7.19332 0 7.51104 0.21348 7.6491 0.542526ZM20.9655 0.542526L26.9292 14.7561C27.0451 15.032 27.0169 15.3487 26.8544 15.599C26.6918 15.8494 26.4167 16 26.1218 16H15.835C15.4834 16 15.1657 15.7865 15.0276 15.4575L9.0638 1.24391C8.94805 0.96793 8.97616 0.651331 9.13869 0.400993C9.30126 0.1506 9.57637 0 9.87131 0H20.1581C20.5097 0 20.8274 0.21348 20.9655 0.542526Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 13.4999,
    y1: 0,
    x2: 13.4999,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28F14"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogMenu5);
export default __webpack_public_path__ + "static/media/catalog-menu-5.1c0d458410c6c8f4cd10a0529ee5ec04.svg";
export { ForwardRef as ReactComponent };